module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_Transition_00096.2d67dcd4.png";